import {
  Grid,
  IconButton,
  MenuItem,
  Typography,
  styled,
} from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { MenuHeader, SimpleMenu } from "../../UI/Menus";

import Avatar from "components/UI/Avatar";
import { TabsProfile } from "store/ProfileStore";
import { lang } from "../../../i18nLang";
import {
  AccessProfileStore,
  MessageStore,
  ProfileStore,
  UserStore,
} from "../../../store";

const EmailText = styled(Typography)({ fontWeight: 300, fontSize: "0.75rem" });
const LogoutButton = styled(MenuItem)(({ theme }) => ({
  borderTop: "1px solid" + theme.palette.gray.main,
}));

interface MenuProfileProps {
  /**
   * Classes para personalizar o estilo do botão do menu.
   */
  classes: {
    button_icon: string;
  };
}

/** Menu suspenso com informações do usuário logado e ações para o mesmo.
 * @category Components
 */
const MenuProfile = observer(({ classes }: MenuProfileProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const user = UserStore.currentUser;
  const photo = UserStore.userPhoto;

  const handleClickLogout = () => UserStore.signOut();

  const handleClick = (ev) => {
    setAnchorEl(ev.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickMyProfile = () => {
    ProfileStore.openProfileLayer(TabsProfile.MY_PROFILE);
    handleClose();
  };

  const handleClickEnterprise = () => {
    if (!AccessProfileStore.currentUserIsAdmin()) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }
    ProfileStore.openProfileLayer(TabsProfile.COMPANY);
    handleClose();
  };

  const handleClickUsers = () => {
    if (!AccessProfileStore.currentUserIsAdmin()) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }
    ProfileStore.openProfileLayer(TabsProfile.USERS);
    handleClose();
  };

  const handleClickAccessProfile = () => {
    ProfileStore.openProfileLayer(TabsProfile.ACCESS_PROFILE);
    handleClose();
  };

  return (
    <>
      <IconButton
        className={classes.button_icon}
        title={lang("user")}
        onClick={handleClick}
      >
        <Avatar file={photo} size={"1.4rem"} />
      </IconButton>
      <SimpleMenu
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuHeader
          container
          alignItems="center"
          justifyContent="center"
          spacing={1}
        >
          <Grid
            container
            item
            xs
            justifyContent="center"
            style={{ maxWidth: 44 }}
          >
            <Avatar file={photo} size={"2.4rem"} />
          </Grid>
          <Grid item xs>
            <Typography variant="body1" style={{ fontWeight: 700 }} noWrap>
              {user ? user.name : lang("user")}
            </Typography>
            <EmailText variant="body2" noWrap>
              {user ? user.email : "user@domain.com"}
            </EmailText>
          </Grid>
        </MenuHeader>
        <MenuItem onClick={handleClickMyProfile}>
          {lang("userProfile.myProfile")}
        </MenuItem>
        <MenuItem onClick={handleClickEnterprise}>
          {lang("userProfile.enterprise")}
        </MenuItem>
        <MenuItem onClick={handleClickUsers}>
          {lang("userProfile.collaborators")}
        </MenuItem>
        {AccessProfileStore.currentUserIsAdmin() && (
          <MenuItem onClick={handleClickAccessProfile}>
            {lang("userProfile.accessProfile")}
          </MenuItem>
        )}
        <LogoutButton onClick={handleClickLogout}>
          {lang("logout")}
        </LogoutButton>
      </SimpleMenu>
    </>
  );
});

export default MenuProfile;
